import { apiClient } from '../../client'
import endpoints from '../../endpoints'
import { unwrapSingle } from '../../normalize'
import { HolisticPlanIssues } from '../../../../types/apiModels'

export default async function getHolisticPlanIssues({
  farmId,
  year,
  signal,
}: {
  farmId: string
  year: string
  signal?: AbortSignal
}): Promise<HolisticPlanIssues> {
  const response = await apiClient.get(endpoints.v2.farms.holisticPlanIssues(farmId), {
    params: { year },
    signal,
  })
  return unwrapSingle<HolisticPlanIssues>(response)
}
